export const FETCH_MASTER_PARAMETERS = "FETCH_MASTER_PARAMETERS";

export const FETCH_MASTER_LATE_MINUTES_DEDUCTION_FORMULAS =
  "FETCH_MASTER_LATE_MINUTES_DEDUCTION_FORMULAS";
export const EDIT_MASTER_PARAMETERS = "EDIT_MASTER_PARAMETERS";
export const CREATE_MASTER_PARAMETER = "CREATE_MASTER_PARAMETER";
export const UPDATE_MASTER_PARAMETER = "UPDATE_MASTER_PARAMETER";
export const DELETE_MASTER_PARAMETER = "DELETE_MASTER_PARAMETER";
export const DB_RE_INDEXING = "DB_RE_INDEXING";
